module.exports = __webpack_public_path__ + "static/media/thread2.9f81d32e.jpg";